"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __importDefault(require("angular"));
class RingtoneDeviceController {
    constructor(mediaDevices, xcHelperPreferences, webRtcAudio) {
        this.mediaDevices = mediaDevices;
        this.xcHelperPreferences = xcHelperPreferences;
        this.webRtcAudio = webRtcAudio;
        this.devices = [];
        this.ringingDeviceId = this.xcHelperPreferences.getRingingDeviceId();
        this.init(this.ringingDeviceId);
    }
    init(ringingDeviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.devices = yield this.mediaDevices.getAudioOutput();
            if (!this.containsDeviceId(this.devices, ringingDeviceId))
                this.changeRingingDevice("default");
        });
    }
    changeRingingDevice(id) {
        this.webRtcAudio.changeRingingDevice(id).then(() => {
        }, () => {
            angular_1.default.noop();
        });
        this.ringingDeviceId = id;
        this.xcHelperPreferences.setRingingDeviceId(id);
    }
    containsDeviceId(devices, deviceId) {
        return devices.find(device => device.deviceId == deviceId);
    }
}
exports.default = RingtoneDeviceController;
RingtoneDeviceController.$inject = [
    "mediaDevices", "xcHelperPreferences", "webRtcAudio"
];
